import React, { useState, useRef, useContext } from "react";
import CollapsibleSidebarLayoutView from "./view";
import useLocalStorage from "../../../hooks/useLocalStorage";

const CollapsibleSidebarContext = React.createContext();

export function useCollapsibleSidebarLayout() {
  return useContext(CollapsibleSidebarContext);
}

export default function CollapsibleSidebarLayout({
  sidebar,
  main,
  wrapperClasses,
  initialSidebarWidth,
  minSidebarWidth,
  maxSidebarWidth,
  icon,
  label,
  id,
  isInverse,
}) {
  const [isResizing, setIsResizing] = useState(false);
  const [isCollapsed, setIsCollapsed] = useLocalStorage(
    `collapse-${id}`,
    false
  );
  const [cachedSidebarWidth, setCachedSidebarWidth] = useState(0);
  const [lastX, setLastX] = useState(0);
  const [lastSidebarWidth, setLastSidebarWidth] = useLocalStorage(
    `last-${id}`,
    0
  );

  const sidebarRef = useRef();
  const onMouseDown = (e) => {
    if (sidebarRef.current) {
      setIsResizing(true);
      setLastX(e.clientX);

      let currentWidth = sidebarRef.current.style.width.replace(
        /[^-?\d.]/g,
        ""
      );
      setCachedSidebarWidth(+currentWidth);
    }
  };

  const onMouseMove = (e) => {
    if (!isResizing) return;

    let slideX = e.clientX - lastX;
    let targetWidth = isInverse
      ? cachedSidebarWidth - slideX
      : cachedSidebarWidth + slideX;

    if (targetWidth > maxSidebarWidth) return;
    if (targetWidth < minSidebarWidth) return setIsCollapsed(true);

    sidebarRef.current.style.width = `${targetWidth}px`;
    setLastSidebarWidth(targetWidth);
  };

  const onMouseUp = () => {
    setIsResizing(false);
    setLastX(0);
    setCachedSidebarWidth(0);
  };

  const value = {
    isResizing,
    isCollapsed,
  };

  return (
    <CollapsibleSidebarContext.Provider value={value}>
      <CollapsibleSidebarLayoutView
        sidebar={sidebar}
        main={main}
        wrapperClasses={wrapperClasses}
        initialSidebarWidth={initialSidebarWidth}
        lastSidebarWidth={lastSidebarWidth}
        mouse={{
          move: onMouseMove,
          up: onMouseUp,
          down: onMouseDown,
        }}
        isCollapsed={{ val: isCollapsed, set: setIsCollapsed }}
        sidebarRef={sidebarRef}
        icon={icon}
        label={label}
        isInverse={isInverse}
      />
    </CollapsibleSidebarContext.Provider>
  );
}
